<script lang="ts" setup>
import FadeSlideTransition from '@shared/animation/transitions/FadeSlideTransition/FadeSlideTransition.vue';
import { FontAwesomeIcon } from '@shared/plugin/icons';

export type VCollapsibleContentBoxProps = {
  theme?: 'decorated' | 'minimal';
};

const props = withDefaults(defineProps<VCollapsibleContentBoxProps>(), {
  theme: 'decorated',
});

const open = defineModel<boolean>('open', { default: false });

function toggleOpen() {
  open.value = !open.value;
}
</script>

<template>
  <div class="rounded border border-solid border-grey-200 bg-white">
    <div
      :class="[
        'sticky top-[calc(var(--header-height)+var(--subheader-height,0px))] z-50 flex min-h-[60px] items-center justify-between px-4 py-2 text-lg xl:top-(--header-height)',
        {
          'border-b border-solid border-grey-200 bg-grey-100': props.theme === 'decorated',
          'bg-white': props.theme === 'minimal',
        },
      ]"
    >
      <div class="flex grow items-center gap-4">
        <button
          aria-roledescription="collapse"
          :class="[
            'flex h-10 cursor-pointer items-center justify-center focus:outline-none',
            {
              'w-10 rounded border border-solid border-grey-200 bg-white hover:bg-grey-200':
                props.theme === 'decorated',
              '-mx-2 px-2': props.theme === 'minimal',
            },
          ]"
          type="button"
          @click="toggleOpen"
        >
          <FontAwesomeIcon
            icon="fas fa-chevron-right"
            class="origin-center text-primary transition-transform duration-300"
            :class="{ 'rotate-90': open }"
          />
        </button>

        <div class="grow py-1 overflow-wrap-anywhere text-primary-900">
          <slot name="header"></slot>
        </div>
      </div>

      <slot name="header-end"></slot>
    </div>
    <FadeSlideTransition direction="down">
      <div v-if="open">
        <slot></slot>
      </div>
    </FadeSlideTransition>
  </div>
</template>
